import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Chip } from '@mui/material';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import styles from './RewardBadge.module.less';

const RewardBadge = ({ amount, position = 'top' }) => {
  if (!amount || amount <= 0) {
    return null;
  }

  return (
    <Box className={`${styles.rewardBadgeContainer} ${styles[position]}`}>
      <Chip
        icon={<CardGiftcardIcon />}
        label={
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Typography variant="body2" component="span" sx={{ fontWeight: 600 }}>
              Earn ${amount}
            </Typography>
            <Typography variant="caption" component="span" sx={{ opacity: 0.9 }}>
              Gift Card
            </Typography>
          </Box>
        }
        color="success"
        className={styles.rewardChip}
        sx={{
          height: 'auto',
          padding: '12px 16px',
          fontSize: '16px',
          fontWeight: 600,
          boxShadow: '0 4px 12px rgba(76, 175, 80, 0.3)',
          '& .MuiChip-icon': {
            fontSize: '24px',
            marginLeft: '4px',
          },
        }}
      />
    </Box>
  );
};

RewardBadge.propTypes = {
  amount: PropTypes.number.isRequired,
  position: PropTypes.oneOf(['top', 'bottom', 'inline']),
};

RewardBadge.defaultProps = {
  position: 'top',
};

export default RewardBadge;



// WEBPACK FOOTER //
// ./src/components/CampaignLanding/RewardBadge.jsx